import { GenericFeatureFlags } from 'domains/featureFlags'

import { getUsersFeatureFlags } from '../api/featureFlags'

import { getUserProfile } from './auth'

const STORAGE_KEY = 'phi_migration_phase'
const PHOTOS_FROM_PHI_STORAGE_KEY = 'phi_photos_from_phi'
const DEFAULT_PHI_MIGRATION_PHASE = 'NONE'

let inMemoryPhase: string | null = null
let photosFromPhi = localStorage.getItem(PHOTOS_FROM_PHI_STORAGE_KEY) === 'true'

const readBoolean = (flags: GenericFeatureFlags | null | undefined, key: string): boolean => {
  const featureFlags = flags?.['FeatureFlags']

  if (featureFlags && typeof featureFlags === 'object') {
    const value = (featureFlags as Record<string, unknown>)[key]

    return value === true
  }
  return false
}

const setPhiFeatureFlagsFromUserFlags = (flags: GenericFeatureFlags | null | undefined) => {
  photosFromPhi = readBoolean(flags, 'PhotosFromPhi')
  localStorage.setItem(PHOTOS_FROM_PHI_STORAGE_KEY, String(photosFromPhi))
}

const clearPhiFeatureFlags = () => {
  photosFromPhi = false
  localStorage.removeItem(PHOTOS_FROM_PHI_STORAGE_KEY)
}

export const isPhotosFromPhiEnabled = (): boolean => photosFromPhi

export const setPhiPhase = (phase: string) => {
  inMemoryPhase = phase
  localStorage.setItem(STORAGE_KEY, phase)
}

export const getPhiPhase = (): string => {
  if (inMemoryPhase) return inMemoryPhase
  const stored = localStorage.getItem(STORAGE_KEY)

  return stored ?? DEFAULT_PHI_MIGRATION_PHASE
}

export const clearPhiPhase = () => {
  inMemoryPhase = null
  localStorage.removeItem(STORAGE_KEY)
  clearPhiFeatureFlags()
}

export const loadPhiPhase = async (): Promise<string> => {
  const profile = getUserProfile()
  const username = profile?.user_name ?? profile?.sub

  if (!username) {
    setPhiPhase(DEFAULT_PHI_MIGRATION_PHASE)
    clearPhiFeatureFlags()
    return DEFAULT_PHI_MIGRATION_PHASE
  }

  try {
    const flags = await getUsersFeatureFlags(username, 'web')

    setPhiFeatureFlagsFromUserFlags(flags)
    const migrations = flags?.['Migrations']
    const value =
      migrations && typeof migrations === 'object'
        ? (migrations as Record<string, unknown>)['phi-migration-phase']
        : null
    const phase = typeof value === 'string' ? value : DEFAULT_PHI_MIGRATION_PHASE

    setPhiPhase(phase)
    return phase
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    setPhiPhase(DEFAULT_PHI_MIGRATION_PHASE)
    clearPhiFeatureFlags()
    return DEFAULT_PHI_MIGRATION_PHASE
  }
}
